/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LinkList from 'gatsby-core-theme/src/components/molecules/link-list';
import { imagePrettyUrl } from 'gatsby-core-theme/src/helpers/getters';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import useTranslate from '~hooks/useTranslate/useTranslate';
import ToplistRow from '../../../../toplist/header/row/index';
import styles from './template-two.module.scss';

const TemplateTwo = ({ page, description }) => {
  const [fullDescription, setFullDescription] = useState(false);

  let toplistModule = null;
  let headerMenu = null;
  page?.sections?.header?.modules?.forEach((element) => {
    if (element?.name === 'menu') {
      headerMenu = element;
    } else if (element?.name === 'top_list') {
      toplistModule = element;
    }
  });

  const RatingText = useTranslate('rating_header', 'Ratings based on:');

  const color = page?.extra_fields?.header_background_color;
  const bgImage = page?.extra_fields?.header_background_image;

  return (
    <div className={styles.container} style={color ? { background: color } : {}}>
      {bgImage && (
        <LazyImage
          alt="bgImage"
          loading="eager"
          width={1400}
          height={632}
          src={imagePrettyUrl(bgImage, 1400, 632)}
          className={styles.bgImage}
        />
      )}

      <div className={styles.topContainer}>
        <h1 className={styles.pageTitle}>{page.title}</h1>

        {description && (
          <>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: description }}
              className={`${styles.description} ${fullDescription ? styles.fullDescription : ''}`}
            />
            <div
              role="button"
              tabIndex={0}
              className={`${styles.readMore} ${fullDescription ? styles.hideReadMore : ''}`}
              onClick={() => setFullDescription(true)}
            >
              <span>Read more</span>
            </div>
          </>
        )}

        {headerMenu?.children?.length > 0 && (
          <div className={styles.headerMenu}>
            <span>{RatingText}</span>
            <LinkList
              showListTitle={false}
              imageOnly
              singleList
              lists={headerMenu}
              width={105}
              height={20}
              gtmClass="mobile-menu-gtm logo-cta"
            />
          </div>
        )}
      </div>
      {toplistModule && (
        <ul className={`${styles.toplistContainer || ''}`}>
          {toplistModule.items.map((item) => (
            <ToplistRow
              toplist={item}
              tracker={item.tracker}
              oneliner={item.one_liner}
              pageTemplate={page?.template}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

TemplateTwo.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string,
    template: PropTypes.string,
    sections: PropTypes.shape({
      header: PropTypes.shape({
        modules: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    }),
    extra_fields: PropTypes.shape({
      header_background_color: PropTypes.string,
      header_background_image: PropTypes.string,
    }),
  }),
  description: PropTypes.shape({}),
};

export default TemplateTwo;
